import { createFileRoute } from '@tanstack/react-router';
// Import as a URL instead of a side effect so Payload's global resets are only
// attached when this pathless admin layout is matched.
import payloadCss from '@payloadcms/ui/css/app.css?url';

import { getLayoutDataFn } from './_payload/server.functions.js';

// Vite's dev `?url` points at a CSS import module. A stylesheet link needs the
// direct text/css response; production already resolves this to an asset URL.
const payloadCssHref = import.meta.env.DEV ? `${payloadCss}?direct` : payloadCss;

export const Route = createFileRoute('/_payload')({
  loader: {
    handler: () => getLayoutDataFn(),
    staleReloadMode: 'blocking',
  },
  head: () => ({
    links: [{ rel: 'stylesheet', href: payloadCssHref }],
  }),
} as never);
